<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <woot-modal-header :header-title="$t('EXPORT_CONTACTS.NEW_PAYMENT_TEXT')" />
    <div class="remainder-table">
      <div class="remainder-modal">
        <div class="remainder-input">
          <div>
            <div>
              <div class="flex justify-between">
                <div class="w-[40%]">
                  <multiselect
                    v-model="assignedProject"
                    track-by="id"
                    label="name"
                    placeholder="Select a Board"
                    selected-label
                    select-label=""
                    deselect-label=""
                    :custom-label="projectLabel"
                    :max-height="160"
                    :options="boards"
                    :allow-empty="true"
                    :option-height="104"
                    @input="onBoardChange"
                  />
                </div>
                <div class="w-[40%]">
                  <woot-input
                    class="status-name mt-2"
                    :class="{ error: $v.gstNumber.$error }"
                    :placeholder="$t('LABEL_MGMT.FORM.NAME.GST_PLACEHOLDER')"
                    :error="gstNumberError"
                    v-model.trim="gstNumber"
                    @input="$v.gstNumber.$touch"
                  />
                </div>
              </div>
              <div class="flex justify-between">
                <div class="w-[40%]">
                  <multiselect
                    v-model="assignedProjectType"
                    track-by="id"
                    label="name"
                    placeholder="Select a Status"
                    selected-label
                    :select-label="
                      $t('CONTACT_FORM.FORM.STATUS.SELECT_PLACEHOLDER')
                    "
                    :deselect-label="$t('CONTACT_FORM.FORM.STATUS.REMOVE')"
                    :custom-label="projectLabel"
                    :max-height="160"
                    :options="states"
                    :allow-empty="true"
                    :option-height="104"
                    @input="onClickAssignProjectType"
                  />
                </div>
                <div class="w-[40%]">
                  <woot-input
                    v-model.trim="amount"
                    class="w-full label-name--input"
                    :class="{ error: $v.amount.$error }"
                    :placeholder="$t('LABEL_MGMT.FORM.NAME.AMOUNT_PLACEHOLDER')"
                    :error="amountError"
                    data-testid="label-title"
                    @input="$v.amount.$touch"
                  />
                </div>
              </div>
            </div>
            <div>
              <div class="w-full">
                <multiselect
                  v-model="paymentType"
                  track-by="id"
                  label="name"
                  placeholder="Select a Payment Type"
                  selected-label
                  :select-label="
                    $t('CONTACT_FORM.FORM.STATUS.SELECT_PLACEHOLDER')
                  "
                  :deselect-label="$t('CONTACT_FORM.FORM.STATUS.REMOVE')"
                  :custom-label="projectLabel"
                  :max-height="160"
                  :options="paymentTypeList"
                  :allow-empty="true"
                  :option-height="104"
                  @input="onClickPaymentType"
                />
              </div>
            </div>
            <div>
              <label>
                {{ $t('PIPELINES.EDIT_DESCRIPTION') }}
                <div class="my-editor mt-2">
                  <div class="editor-ui rounded-md">
                    <editor
                      v-model="description"
                      :placeholder="'Add Remark...'"
                    />
                  </div>
                </div>
              </label>
            </div>
          </div>
          <div class="flex justify-end items-center pb-6 pt-2 gap-2 w-full">
            <woot-submit-button
              :disabled="
                uiFlags.isCreating ||
                $v.gstNumber.$invalid ||
                $v.amount.$invalid ||
                gstNumber.length === 0 ||
                amount.length === 0 ||
                assignedProject == null ||
                assignedProjectType == null ||
                paymentType == null
              "
              :button-text="'Submit'"
              class="button-color"
              @click="createNewpayment"
            />
            <woot-button
              class="button clear cancel-btn"
              @click.prevent="onClose"
            >
              {{ $t('LABEL_MGMT.FORM.CANCEL') }}
            </woot-button>
          </div>
        </div>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import Editor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import validations from 'dashboard/routes/dashboard/settings/payments/helpers/validations';
import paymentsMixin from 'dashboard/routes/dashboard/settings/payments/helpers/paymentsMixin.js';
export default {
  components: {
    Editor,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      assignedProject: null, // bound to the selected item
      assignedProjectType: null,
      paymentTypeList: [
        {
          id: 0,
          name: 'Cash',
        },
        {
          id: 1,
          name: 'UPI',
        },
        {
          id: 2,
          name: 'Card',
        },
        {
          id: 3,
          name: 'Check',
        },
      ],
      gstNumber: '',
      amount: '',
      description: '',
      states: [],
      paymentType: null,
    };
  },
  validations,
  mounted() {
    console.log('New Payment', this.show);
    this.getBoards();
  },
  mixins: [alertMixin, paymentsMixin],
  computed: {
    ...mapGetters({
      uiFlags: 'payments/getUIFlags',
      currentUser: 'getCurrentUser',
    }),
    boards() {
      // return this.$store.getters['pipelines/getAllBoards'];
      console.log('My Boards', this.$store.getters['pipelines/getAllBoards']);
      return [...this.$store.getters['pipelines/getAllBoards']];
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    projectLabel(option) {
      return `${option.name}`;
    },
    projectLabel(option) {
      return `${option.name}`;
    },
    async createNewpayment() {
      const payload = {
        payment: {
          amount: this.amount,
          created_by_id: this.currentUser.id, // hardcoded, or make dynamic if needed
          contact_id: this.contact.id,
          status_id: this.contact.status_id,
          gst_no: this.gstNumber, // also hardcoded, or use selected value
          description: this.description,
          board_id: this.assignedProject.id,
          status_id: this.assignedProjectType.id,
          payment_type: this.paymentType.id,
        },
      };
      console.log('Payload to send:', payload);
      try {
        const response = await this.$store.dispatch('payments/makePayment', payload);
        this.onClose();
        this.showAlert(response.data.message, { success: response.data.success });
        this.resetdata();
        this.getNewPayment();
      } catch (error) {
        const message = error.response.data.message || 'Payment failed';
        this.showAlert(message, { success: false });
      }
    },
    resetdata() {
      this.amount = '';
      this.gstNumber = '';
      this.description = '';
      this.assignedProject = null;
      this.assignedProjectType = null;
      this.paymentType = null;
      this.$v.$reset();
    },
    getNewPayment() {
      this.$emit('getNewPayment');
    },
    async getStatus(board) {
      this.loadingSelection = true;
      const data = {
        board_id: board.id,
      };
      console.log('Fetching board status:', data);

      try {
        const response = await this.$store.dispatch(
          'pipelines/getStatusFromBoard',
          data
        );
        const allStates = response.data.data || [];
        this.states = allStates.filter(state => state.allow_payment === true);
      } catch (error) {
        console.error('Error fetching status list:', error);
      } finally {
        this.loadingSelection = false;
      }
    },
    getBoards() {
      this.$store.dispatch('pipelines/getBoards');
    },
    async onBoardChange(board) {
      this.assignedProject = board; // just to be sure it's synced
      this.assignedProjectType=null;
      if (board && board.id) {
        await this.getStatus(board);
      }
    },
    async onClickAssignProjectType(status){
      this.assignedProjectType=status;
    }
  },
};
</script>

<style lang="scss" scoped>
.button-color {
  background-color: #40518a;
}

.cancel-btn:hover {
  background-color: #f9f9f9;
  color: #40518a;
}

.cancel-btn {
  background-color: #fff;
  color: #40518a;
}

.remainder-table {
  margin: 10px 35px;
}

.remainder-modal {
  display: flex;
}

.remainder-input {
  width: 100%;
}

.date-time {
  display: flex;
  justify-content: space-between;
}

.date-time-input {
  width: 100%;
}

.editor-ui {
  border: 2px solid lightgrey;
  height: 200px;
  padding-left: 10px;
}

// ::v-deep .multiselect__option.multiselect__option--highlight.multiselect__option--selected:hover::after {
//   content: "Remove" !important;
// }

// ::v-deep .multiselect__option.multiselect__option--highlight.multiselect__option--selected:hover::after {
//   background-color: rgb(155, 193, 219) !important;
//   color: white;
//   padding: 2px 6px;
//   margin-left: 10px;
//   font-size: 12px;
//   border-radius: 4px;
//   font-weight: 500;
// }

// ::v-deep .multiselect__option.multiselect__option--highlight:not(.multiselect__option--selected):hover::after {
//   content: 'Select';
//   background-color: #40518a !important; // or any color you want
//   color: white;
//   padding: 2px 6px;
//   margin-left: 10px;
//   font-size: 12px;
//   border-radius: 4px;
//   font-weight: 500;
// }


// First, hide the ::after pseudo-element by default
::v-deep .multiselect__option:not(.multiselect__option--selected)::after {
  content: none !important;
}


</style>
